'use client';

import { useTranslations } from 'next-intl';
import { Badge } from '@/components/ui/badge';
// import { SortingMetrics } from './sorting-metrics';
import { SortingListing } from './sorting-listing';

export function SortingPageContent() {
  const t = useTranslations('sorting');

  return (
    <div className='space-y-6'>
      <div className='flex items-center justify-between'>
        <h1 className='text-2xl font-bold tracking-tight'>{t('pageTitle')}</h1>
        <Badge
          variant='outline'
          className='border-amber-300 bg-amber-50 text-amber-700'
        >
          {t('phaseBadge')}
        </Badge>
      </div>
      <p className='text-muted-foreground text-sm'>{t('pageSubtitle')}</p>
      {/* <SortingMetrics /> */}
      <SortingListing />
    </div>
  );
}
